import { apiService } from '../APIService';

export default {
  getAwardLevels() {
    return apiService.getCached('/public/lists/event-levels');
  },

  getEventTypes() {
    return apiService.getCached('/public/lists/event-types');
  },
};
